<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="operations">
          <div class="filters">
            <el-form :inline="true" label-width="60px" label-position="left">
              <el-form-item :label="$t('baseInfo.usCommodityCode.systemCode')">
                <el-input v-model="condition.code" style="width: 150px" />
              </el-form-item>
              <el-form-item :label="$t('baseInfo.usCommodityCode.tradeName')">
                <el-input v-model="condition.commodityName" style="width: 260px" />
              </el-form-item>
              <el-form-item label="HSCODE">
                <el-input v-model="condition.hsCode" style="width: 150px" />
              </el-form-item>
            </el-form>
          </div>
          <div class="triggers">
            <div>
              <el-button type="primary" @click="toQuery(condition)">{{ $t('common.btn.query') }}</el-button>
              <el-button :disabled="!selectedNode" type="primary" @click="toLook">{{ $t('common.btn.look') }}</el-button>
              <el-button type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
              <el-button :disabled="!selectedNode" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
              <el-button :disabled="!selectedNode" type="primary" @click="toDelete">{{ $t('common.btn.delete') }}</el-button>
              <el-button type="primary" @click="downloadTemplate">{{ $t('CargoMsg.Cargo_TemplateDownload') }}</el-button>
              <!--导入-->
              <el-upload
                :action="importExcelDataUrl"
                accept=".xls, .xlsx"
                :show-file-list="false"
                :before-upload="beforeUpload"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                style="display: inline-block;margin-left: 5px"
              >
                <el-button type="primary">{{ $t('CargoMsg.Cargo_Import') }}</el-button>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="100402"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="100402"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery()"
          />
        </div>
      </div>
    </div>
    <!-- 查看弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="lookDialog.visible"
      :title="$t('common.btn.look')"
      width="730px"
      :close-on-click-modal="false"
    >
      <el-form :inline="true" label-width="140px" label-position="right">
        <el-form-item :label="$t('baseInfo.usCommodityCode.systemCode')">
          <span>{{ lookDialog.form.code }}</span>
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.tradeName')">
          <span>{{ lookDialog.form.commodityName }}</span>
        </el-form-item>
        <el-form-item label="HSCODE">
          <span>{{ lookDialog.form.hsCode }}</span>
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.productDescription')">
          <span>{{ lookDialog.form.commodityDescription }}</span>
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.descriptionCode')">
          <span>{{ lookDialog.form.descriptionCode }}</span>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Status')">
          <span>{{ lookDialog.form.status === 1 ? $t('baseInfo.usCommodityCode.enable') : $t('baseInfo.usCommodityCode.disable') }}</span>
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.customsTariff')" class="w210">
          <span>
            {{ lookDialog.form.customsRate }}%
            <span style="padding: 0 10px">+</span>
            ${{ lookDialog.form.customsRateAmount }}/KG
          </span>
        </el-form-item>
        <br>
        <el-form-item :label="$t('baseInfo.usCommodityCode.chinaSurtaxTariff')">
          <div style="display: inline">
            <span>{{ lookDialog.form.chinaAdditionalTaxRule }}</span>
            <span style="float: right">{{ lookDialog.form.chinaAdditionalRate }}</span>
          </div>
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.additionalTaxRate056')">
          <span>${{ lookDialog.form.additionalRate056 }}/KG</span>
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.including499AdditionalTaxRate')">
          <i v-show="lookDialog.form.containAdditionalTax499" class="el-icon-check" style="font-size: 16px;" />
          <i v-show="!lookDialog.form.containAdditionalTax499" class="el-icon-close" style="font-size: 16px;" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.including501AdditionalTaxRate')">
          <i v-show="lookDialog.form.containAdditionalTax501" class="el-icon-check" style="font-size: 16px;" />
          <i v-show="!lookDialog.form.containAdditionalTax501" class="el-icon-close" style="font-size: 16px;" />
        </el-form-item>
        <br>
        <el-form-item :label="$t('baseInfo.usCommodityCode.chinaHongKongSurtaxTariff')">
          <div style="display: inline">
            <span>{{ lookDialog.form.chinaHongKongAdditionalTaxRule }}</span>
            <span style="float: right">{{ lookDialog.form.chinaHKAdditionalRate }}</span>
          </div>
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.remark')" prop="remark">
          <el-input v-model="lookDialog.form.remark" disabled type="textarea" :maxlength="255" :rows="3" size="mini" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="lookDialog.visible=false;showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button @click="lookDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="730px"
      :close-on-click-modal="false"
    >
      <el-form :inline="true" label-width="140px" label-position="right">
        <el-form-item :label="$t('baseInfo.usCommodityCode.systemCode')">
          <el-input v-model="editDialog.form.code" maxlength="50" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.tradeName')">
          <el-input v-model="editDialog.form.commodityName" :filter-chars="false" maxlength="50" />
        </el-form-item>
        <el-form-item label="HSCODE">
          <el-input v-model="editDialog.form.hsCode" maxlength="20" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.productDescription')">
          <el-input v-model="editDialog.form.commodityDescription" :filter-chars="false" maxlength="50" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.descriptionCode')">
          <el-input v-model="editDialog.form.descriptionCode" maxlength="20" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Status')">
          <el-radio-group v-model="editDialog.form.status">
            <el-radio :label="1">{{ $t('baseInfo.usCommodityCode.enable') }}</el-radio>
            <el-radio :label="0" style="margin-left: -20px;">{{ $t('baseInfo.usCommodityCode.disable') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.customsTariff')" class="w210">
          <div style="display: flex">
            <el-input-number v-model="editDialog.form.customsRate" :precision="2" :min="0" :max="99.99" :controls="false" style="width: 50px" />
            <span>%</span>
            <span style="padding: 0 10px">+</span>
            <span>$</span>
            <el-input-number v-model="editDialog.form.customsRateAmount" :precision="6" :min="0" :controls="false" style="width: 85px" />
            <span>/KG</span>
          </div>
        </el-form-item>
        <br>
        <el-form-item :label="$t('baseInfo.usCommodityCode.chinaSurtaxTariff')">
          <div style="display: inline">
            <el-select
              v-model="editDialog.form.chinaAdditionalTaxRule"
              :placeholder="$t('Message.PleaseSelect')"
              clearable
              style="width: 95px"
              @change="attachTaxRuleInfo(editDialog.form)"
            >
              <el-option value="9903.88.03" />
              <el-option value="9903.88.15" />
              <el-option value="9903.88.42" />
              <el-option value="9903.88.01" />
              <el-option value="9903.88.02" />
            </el-select>
            <span :style="{float: editDialog.form.chinaAdditionalRate && editDialog.form.chinaAdditionalRate.length > 15 ? 'left' : 'right'}">{{ editDialog.form.chinaAdditionalRate }}</span>
          </div>
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.additionalTaxRate056')">
          <div style="display: flex">
            <span>$</span>
            <el-input-number
              v-model="editDialog.form.additionalRate056"
              :precision="6"
              :min="0"
              :max="99.999999"
              :controls="false"
              style="width: 85px"
            />
            <span>/KG</span>
          </div>
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.including499AdditionalTaxRate')">
          <el-checkbox v-model="editDialog.form.containAdditionalTax499" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.including501AdditionalTaxRate')">
          <el-checkbox v-model="editDialog.form.containAdditionalTax501" />
        </el-form-item>
        <br>
        <el-form-item :label="$t('baseInfo.usCommodityCode.chinaHongKongSurtaxTariff')">
          <div style="display: inline">
            <el-select
              v-model="editDialog.form.chinaHongKongAdditionalTaxRule"
              :placeholder="$t('Message.PleaseSelect')"
              clearable
              style="width: 95px"
              @change="attachHKTaxRuleInfo(editDialog.form)"
            >
              <el-option value="9903.01.24" />
              <el-option value="9903.01.20" />
              <el-option value="9903.01.23" />
              <el-option value="9903.01.25" />
            </el-select>
            <span :style="{float: editDialog.form.chinaHKAdditionalRate && editDialog.form.chinaHKAdditionalRate.length > 15 ? 'left' : 'right'}">{{ editDialog.form.chinaHKAdditionalRate }}</span>
          </div>
        </el-form-item>
        <el-form-item :label="$t('baseInfo.usCommodityCode.remark')" prop="remark">
          <el-input v-model="editDialog.form.remark" type="textarea" :maxlength="255" :rows="3" size="mini" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ErrorTip } from '@/utils/class/ErrorTip'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import StrUtils from '@/utils/StrUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { USCommodityCode } from '@/class/model/mdm/USCommodityCode'
import URL from '@/api/urlTranslator'
import { queryUSCommodityCode, saveUSCommodityCode, deleteUSCommodityCode } from '@/api/usCommodityCode'

export default {
  name: 'USCommodityCode',
  data() {
    return {
      loading: null,
      condition: {
        code: '',
        commodityName: '',
        hsCode: ''
      },
      filter: {
        code: '',
        commodityName: '',
        hsCode: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        onRowDataChanged: event => {
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('baseInfo.usCommodityCode.systemCode'),
          field: 'code',
          width: 90
        }, {
          headerName: this.$t('baseInfo.usCommodityCode.tradeName'),
          field: 'commodityName',
          width: 200
        }, {
          headerName: 'HSCODE',
          field: 'hsCode',
          width: 90
        }, {
          headerName: this.$t('baseInfo.usCommodityCode.productDescription'),
          field: 'commodityDescription',
          width: 200
        }, {
          headerName: this.$t('baseInfo.usCommodityCode.descriptionCode'),
          field: 'descriptionCode',
          width: 90
        }, {
          headerName: this.$t('baseInfo.usCommodityCode.customsTariff'),
          field: 'customsRate',
          width: 90,
          valueFormatter: params => {
            return (params.value || 0) + '%'
          }
        }, {
          headerName: this.$t('baseInfo.usCommodityCode.additionalTaxRate056'),
          field: 'additionalRate056',
          width: 150,
          valueFormatter: params => {
            return '$' + (params.value || 0) + '/KG'
          }
        }, {
          headerName: this.$t('baseInfo.usCommodityCode.including499AdditionalTaxRate'),
          field: 'containAdditionalTax499',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('baseInfo.usCommodityCode.including501AdditionalTaxRate'),
          field: 'containAdditionalTax501',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('baseInfo.usCommodityCode.chinaAdditionalTaxRate'),
          field: 'chinaAdditionalRate',
          width: 150
        }, {
          headerName: this.$t('baseInfo.usCommodityCode.chinaSurtaxTariff'),
          field: 'chinaAdditionalTaxRule',
          width: 150
        }, {
          headerName: this.$t('baseInfo.usCommodityCode.chinaSurtaxClause'),
          field: 'chinaAdditionalTaxClause',
          width: 200
        }, {
          headerName: this.$t('baseInfo.usCommodityCode.remark'),
          field: 'remark',
          width: 200,
          hide: true
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      lookDialog: {
        visible: false,
        form: {}
      },
      editDialog: {
        visible: false,
        title: '',
        form: {}
      },
      taxRule01: this.toTaxRule('9903.88.01'),
      taxRule02: this.toTaxRule('9903.88.02'),
      taxRule03: this.toTaxRule('9903.88.03'),
      taxRule15: this.toTaxRule('9903.88.15'),
      taxRule42: this.toTaxRule('9903.88.42'),
      taxRule24: this.toTaxRule('9903.01.24'),
      taxRule25: this.toTaxRule('9903.01.25'),
      taxRule10: this.toTaxRule('9903.01.20'),
      taxRule0: this.toTaxRule('9903.01.23')
    }
  },
  computed: {
    importExcelDataUrl() {
      return `${URL.mdm.usCommodityCode.importExcelData}?sessionId=${this.$store.getters.token}`
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  created() {
    this.toQuery()
  },
  methods: {
    toTaxRule(code) {
      const chargeItem = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'scaleCode', code)
      if (chargeItem) {
        let rate = ''
        if (chargeItem.suitApRate) {
          rate += Number((chargeItem.defaultApRate * 100).toFixed(6)) + '%'
        }
        if (chargeItem.suitSecondApRate) {
          if (rate) {
            rate += ','
          }
          rate += Number((chargeItem.secondApRate * 100).toFixed(6)) + '%'
        }
        return { code, rate, clause: chargeItem.chargecode }
      }
      return { code, rate: '', clause: '' }
    },
    attachTaxRuleInfo(data) {
      let taxRule = null
      switch (data.chinaAdditionalTaxRule) {
        case '9903.88.01':
          taxRule = this.taxRule01
          break
        case '9903.88.02':
          taxRule = this.taxRule02
          break
        case '9903.88.03':
          taxRule = this.taxRule03
          break
        case '9903.88.15':
          taxRule = this.taxRule15
          break
        case '9903.88.42':
          taxRule = this.taxRule42
          break
      }
      if (taxRule) {
        data.chinaAdditionalRate = taxRule.rate
        data.chinaAdditionalTaxClause = taxRule.clause
      } else {
        data.chinaAdditionalRate = ''
        data.chinaAdditionalTaxClause = ''
      }
    },
    // 中国香港附加税税则
    attachHKTaxRuleInfo(data) {
      let taxRule = null
      switch (data.chinaHongKongAdditionalTaxRule) {
        case '9903.01.24':
          taxRule = this.taxRule24
          break
        case '9903.01.25':
          taxRule = this.taxRule25
          break
        case '9903.01.20':
          taxRule = this.taxRule10
          break
        case '9903.01.23':
          taxRule = this.taxRule0
          break
      }
      data.chinaHKAdditionalRate = taxRule ? taxRule.rate : ''
    },
    toQuery(condition) {
      if (condition) {
        Object.assign(this.filter, condition)
        this.filter.pageNum = 1
      }
      const loading = getLoading4Cxt(this)
      queryUSCommodityCode(this.filter).then(res => {
        for (const item of res.data.list) {
          this.attachTaxRuleInfo(item)
          this.attachHKTaxRuleInfo(item)
        }
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => {
        loading.close()
      })
    },
    toLook() {
      this.lookDialog.form = this.selectedNode.data
      this.lookDialog.visible = true
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.title = this.$t('common.btn.new')
        this.editDialog.form = new USCommodityCode().fillDefaultValue().getData()
        this.attachTaxRuleInfo(this.editDialog.form)
        this.attachHKTaxRuleInfo(this.editDialog.form)
      } else {
        this.editDialog.title = this.$t('common.btn.edit')
        this.editDialog.form = { ...this.selectedNode.data }
      }
      this.editDialog.visible = true
    },
    save() {
      const form = this.editDialog.form
      form.code = StrUtils.toHalfword(form.code.trim())
      if (!form.code) {
        throw new ErrorTip(this.$t('CargoMsg.Cargo_PlsInput') + ' ' + this.$t('baseInfo.usCommodityCode.systemCode'))
      }
      if (!form.commodityName) {
        throw new ErrorTip(this.$t('CargoMsg.Cargo_PlsInput') + ' ' + this.$t('baseInfo.usCommodityCode.tradeName'))
      }
      form.hsCode = StrUtils.toHalfword(form.hsCode.trim())
      if (!form.hsCode) {
        throw new ErrorTip(this.$t('CargoMsg.Cargo_PlsInput') + ' HSCODE')
      }
      if (!form.commodityDescription) {
        throw new ErrorTip(this.$t('CargoMsg.Cargo_PlsInput') + ' ' + this.$t('baseInfo.usCommodityCode.productDescription'))
      }
      // form.descriptionCode = StrUtils.toHalfword(form.descriptionCode.trim())
      // if (!form.descriptionCode) {
      //   throw new ErrorTip(this.$t('CargoMsg.Cargo_PlsInput') + ' ' + this.$t('baseInfo.usCommodityCode.descriptionCode'))
      // }
      const loading = getLoading4Cxt(this)
      saveUSCommodityCode(form).then(res => {
        const index = this.rowData.findIndex(p => p.uuid === res.data.uuid)
        if (index >= 0) {
          this.rowData.splice(index, 1, res.data)
        } else {
          this.rowData.push(res.data)
        }
        this.editDialog.visible = false
        this.$message.success(this.$t('Message.SaveSuccessfully'))
      }).finally(() => {
        loading.close()
      })
    },
    toDelete() {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      const row = cell && nodes[cell.rowIndex] ? nodes[cell.rowIndex].data : null
      if (!row) {
        throw new ErrorTip(this.$t('Message.PleaseSelectARecord2'))
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const loading = getLoading4Cxt(this)
        deleteUSCommodityCode(row.uuid).then(res => {
          const index = this.rowData.findIndex(p => p.uuid === row.uuid)
          if (index >= 0) {
            this.rowData.splice(index, 1)
          }
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
        }).finally(() => {
          loading.close()
        })
      }).catch(() => { })
    },
    downloadTemplate() {
      ExportUtils.downloadTemplateFile('US_HSCODE_TEMPLATE.xlsx', 'usCommodityCode')
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (fileType !== 'xls' && fileType !== 'xlsx') {
        throw new ErrorTip(this.$t('Partners.uploadXLSFormatFile'))
      }
      this.loading = getLoading4Cxt(this)
      return true
    },
    uploadSuccess(response, file, fileList) {
      this.loading.close()
      if (response) {
        const { data, errors, message } = response
        if (data) {
          if (data.length > 0) {
            this.rowData.push(...data)
            this.$message.success(this.$t('Message.ImportSuccessful1'))
          } else {
            this.$message.warning(this.$t('Message.ImportFailed'))
          }
        } else if (errors && errors.length > 0) {
          this.$message.warning(Array.from(errors, p => p.message).join(','))
        } else {
          this.$message.warning(message)
        }
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    uploadError() {
      this.loading.close()
      this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
    }
  }
}
</script>

<style scoped lang="scss">
#app .app-main-content ::v-deep {
  .el-dialog {
    .el-form-item__content {
      width: 200px;
    }
    .w210 {
      .el-form-item__content {
        width: 210px;
      }
    }
  }
}
</style>
